import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';
import "./FormManagement.css"
import { useEffect } from 'react';
import { useState } from 'react';
import 'react-accessible-accordion/dist/fancy-example.css';
import { ToastContainer, toast } from 'react-toastify';
import httpClient from '../../HTTPService';
import { useNavigate } from 'react-router-dom';
const FormListing = () => {
    const [getForm, setGetForm] = useState();
    const navigate = useNavigate()

    useEffect(() => {
        getFormList();
    }, []);
    const getFormList = async (query) => {
        try {
            const result = await httpClient.post("/admin/form-list", {
                search_keyword: query
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data.data);
            if (result.data.status == true) {
                // toast.success(result.data.message)
                setGetForm(result.data.data)
            }
            if (result.data.status == false) {
                // toast.error(result.data.message)

            }

        }

        catch (error) {
            // toast.error(error.message)
        }
    }
    const editItem = (e) => {
        console.log(e);
        // const editdata = JSON.stringify(e)
        // const {id} = editdata
        // console.log(editdata)
        navigate(`/formmanagement?id=${e.id}`);
        // navigate('/addCategory', );
        //  localStorage.setItem('editData',editdata)
    }
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }

    const searchHandler = debounce((query) => {
        getFormList(query)
    }, 2000)

    const deletedform = async (id) => {
        try {
            const result = await httpClient.post("/admin/form/delete", {
                id: id
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result);
            if (result.data.status == true) {
                // toast.success(result.data.message)
                // setGetForm(result.data.data)
                toast.success(result.data.message)
                getFormList()
            }
            if (result.data.status == false) {
                toast.error(result.data.message)
                // toast.error(result.data.message)

            }

        }

        catch (error) {
            // toast.error(error.message)
        }
    }
    return (

        <div className="FormList">
            <ToastContainer
                autoClose={1000}
            />
            <div class="search-box" style={{
                position: 'absolute',
                top: 100,
                right: 30
            }} >
                <div class="searchtct">

                    <i class="fa fa-search" aria-hidden="true"></i>
                    <input type="text" name="text" placeholder="Search..."
                        onChange={(val) => searchHandler(val.target.value)}
                    // onKeyDown={() => {
                    //     if (searchtext === '') {
                    //         getreports(searchtext, currentPage, getLimit)
                    //     }
                    // }}
                    />
                    {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                </div>

            </div>
            <ToastContainer
                autoClose={1000}
            />

            <Accordion style={{
                marginTop: 60
            }}>
                {getForm?.map((item, i) => {
                    return <AccordionItem key={i}>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                {/* <div> */}
                                {`${item.category} / ${item.sub_category}`}
                                <i onClick={() => editItem(item)} class="fa fa-pencil icon-button" aria-hidden="true"></i>
                                <i onClick={() => deletedform(item?.id)} class="fa fa-trash icon-button" aria-hidden="true"></i>

                                {/* </div> */}
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className='viewForm'>

                                <div className='row'>
                                    {JSON.parse(item?.form_data).map((frmItem, index) => {
                                        if (frmItem.type == "text") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <input type={frmItem.type} name={frmItem.name} placeholder={frmItem.place_holder}></input>
                                                </div>
                                            </div>
                                        }
                                        if (frmItem.type == "select") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <select>
                                                        <option></option>
                                                    </select>

                                                </div>
                                            </div>
                                        }
                                        if (frmItem.type == "date") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <input type={frmItem.type} name={frmItem.name} placeholder={frmItem.place_holder}></input>

                                                </div>
                                            </div>
                                        }
                                        if (frmItem.type == "time") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <input type={frmItem.type} name={frmItem.name} placeholder={frmItem.place_holder}></input>

                                                </div>
                                            </div>
                                        }
                                        if (frmItem.type == "textarea") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <textarea placeholder={frmItem.place_holder} name={frmItem.name}></textarea>


                                                </div>
                                            </div>
                                        }
                                        if (frmItem.type == "file") {
                                            return <div className='col-md-4' key={index}>
                                                <div className='formGroup'>
                                                    <label>{frmItem.label}</label>
                                                    <input type={frmItem.type} name={frmItem.name}></input>


                                                </div>
                                            </div>
                                        }
                                    })
                                    }
                                </div>

                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                })

                }

            </Accordion>
        </div>
    )
}
export default FormListing;